export default "__VITE_ASSET__a0fdf7b4__"